import { Types }from '../action/action';

interface directnumberState {
  isSuccess: boolean,
  list: any
}

const initialState = {
  isSuccess: false,
  list: []
};

export const directNumberDetail = (state:directnumberState  = initialState, action: any) => {
  const {
    type,
    payloads
  } = action;
  switch (type) {
  case Types.GET_DIRECT_NUMBER:
    return {
      ...state, list: payloads, isSuccess: true
    };
  default:
    return state;
  };
};